<script setup lang="ts"></script>

<template>
  <Toast />
  <ConfirmPopup />
  <DynamicDialog />
  <router-view />
</template>

<style scoped></style>
